import { MutableRefObject, useEffect } from 'react';

const useScrollToTop = (ref: MutableRefObject<any>): void => {
  useEffect(() => {
    ref.current?.scrollTo(0, 0);
  }, [ref]);
};

export default useScrollToTop;
